import c0 from './dashboard/channels/episodes/form_controller';
import c1 from './dashboard/channels/episodes/upload_controller';
import c2 from './dashboard/channels/landing_page/testimonials_controller';
import c3 from './dashboard/shared/posts/auto_resize_controller';
import c4 from './dashboard/shared/posts/form_controller';
import c5 from './dashboard/shared/posts/title_controller';
import c6 from './dashboard/shared/searches/search_results_controller';
export const definitions = [
	{identifier: 'dashboard--channels--episodes--form', controllerConstructor: c0},
	{identifier: 'dashboard--channels--episodes--upload', controllerConstructor: c1},
	{identifier: 'dashboard--channels--landing-page--testimonials', controllerConstructor: c2},
	{identifier: 'dashboard--shared--posts--auto-resize', controllerConstructor: c3},
	{identifier: 'dashboard--shared--posts--form', controllerConstructor: c4},
	{identifier: 'dashboard--shared--posts--title', controllerConstructor: c5},
	{identifier: 'dashboard--shared--searches--search-results', controllerConstructor: c6},
];
